import React from 'react'
import Classes from "../../ClientDetail.module.css"
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'

export default function Sidebar({ activeTab, setActiveTab }) {
    const navigateTo = useNavigate();
  const { tab = "details", id } = useParams();

    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "details" ? Classes.active : ""}
                onClick={() => { navigateTo(`/client-detail/details/${id}`) }}
            >
                <h5>Details</h5>
            </li>

            <li className={activeTab === "appointments" ? Classes.active : ""}
                onClick={() => { navigateTo(`/client-detail/appointments/${id}`) }}
            >
                <h5>Appointments</h5>
            </li>

            <li className={activeTab === "invoices" ? Classes.active : ""}
                onClick={() => { navigateTo(`/client-detail/invoices/${id}`) }}
            >
                <h5>Invoices</h5>
            </li>

            <li className={activeTab === "documents" ? Classes.active : ""}
                onClick={() => { navigateTo(`/client-detail/documents/${id}`) }}
            >
                <h5>Documents</h5>
            </li>
        </ul>
    )
}
